<dworkflow-formly-editor-internal
  [fields]="fields"
  (deleteControl)="onDeleteControl($event)"
  (moveControl)="onMoveControl($event)"
  (addControl)="onAddControl($event)"
  (modifyControl)="onModifyControl($event)"
/>
